// src/App.jsx
// FRONT OFFICE - Main app component with Firebase integration

import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Context Providers
import { AuthProvider } from './contexts/AuthContext';
import { ProductProvider } from './contexts/ProductContext';
import { CartProvider } from './contexts/CartContext';
import { OrderProvider } from './contexts/OrderContext';

// Pages
import Home from './pages/Home/Home';
import Shop from './pages/Shop/Shop';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import MyAccount from './pages/MyAccount/MyAccount';
import Cart from './pages/Cart/Cart';
import Login from './pages/Login/Login';
import Registration from './pages/Registration/Registration';
import Checkout from './pages/Checkout/Checkout';
import Quote from './pages/Quote/Quote';
import OrderConfirmation from './pages/OrderConfirmation/OrderConfirmation';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import OurTeam from './components/OurTeam/OurTeam';
import Prescription from './components/Prescription/prescription';
import ProtectedRoute from './components/Routes/ProtectedRoute';
import ScrollToTop from './components/Shared/ScrollToTop';
import OrderDetail from './pages/OrderDetail/OrderDetail';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <ProductProvider>
          <CartProvider>
            <OrderProvider>
              <div className="app">
                <Header />
                <main className="main-content">
                  <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/registration" element={<Registration />} />
                    <Route path="/quote" element={<Quote />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    
                    {/* Protected routes - require authentication */}
                    <Route 
                      path="/my-account" 
                      element={
                        <ProtectedRoute>
                          <MyAccount />
                        </ProtectedRoute>
                      } 
                    />

                    {/* New route for Order Detail */}
                    <Route 
                      path="/order/:id" 
                      element={
                        <ProtectedRoute>
                          <OrderDetail />
                        </ProtectedRoute>
                      } 
                    />

                    <Route 
                      path="/cart" 
                      element={
                        <ProtectedRoute>
                          <Cart />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/checkout" 
                      element={
                        <ProtectedRoute>
                          <Checkout />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/order-confirmation" 
                      element={
                        <ProtectedRoute>
                          <OrderConfirmation />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/prescription" 
                      element={
                        <ProtectedRoute>
                          <Prescription />
                        </ProtectedRoute>
                      } 
                    />

                    {/* Fallback route */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            </OrderProvider>
          </CartProvider>
        </ProductProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
















